import { createStore } from 'vuex'
import { account } from "./account.module"
import { auth } from "./auth.module"
import { payment_inprogress } from "./payment_inprogress.module"
import { profil } from "./profil.module"
import { token } from "./token.module"
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  key: 'store-lep-prdv',
  modules: ['account', 'auth', 'payment_inprogress', 'profil', 'token'],
})

const store = createStore({
  modules: {
    account,
    auth,
    payment_inprogress,
    profil,
    token,
  },
  plugins: [vuexLocal.plugin,],
});

export default store
